import { Box, makeStyles, Tooltip, Typography } from '@material-ui/core';
import { Item } from './item';

const useStyles = makeStyles(() => ({
  okCircleStyle: {
    backgroundColor: '#1ACF77',
    height: '8px',
    width: '8px',
    borderRadius: '100%',
  },
  manuallyApprovedCircleStyle: {
    backgroundColor: '#FB8C00',
    height: '8px',
    width: '8px',
    borderRadius: '100%',
  },
  problemCircleStyle: {
    backgroundColor: '#E54234',
    height: '8px',
    width: '8px',
    borderRadius: '100%',
  },
}));

interface InspectionPhotosStatsProps {
  totalPhotos: number;
  okPhotos: number;
  manuallyApprovedPhotos?: number;
  photosWithIssues: number;
  showEmptyResult?: boolean;
}

export const InspectionPhotosStats = ({
  totalPhotos,
  okPhotos,
  manuallyApprovedPhotos,
  photosWithIssues,
  showEmptyResult = false,
}: InspectionPhotosStatsProps) => {
  const classes = useStyles();

  // don't show any results if no photos were uploaded, unless showEmptyResult is set
  if (totalPhotos == 0 && !showEmptyResult) {
    return null;
  }

  return (
    <Item title={`${totalPhotos} Photos`}>
      <Box display="flex" gridGap="8px">
        {okPhotos > 0 && (
          <Tooltip title="Validation Sucessful">
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gridGap="4px"
            >
              <Box className={classes.okCircleStyle} />
              <Typography variant="body2">{okPhotos}</Typography>
            </Box>
          </Tooltip>
        )}
        {manuallyApprovedPhotos > 0 && (
          <Tooltip title="Manually Approved">
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gridGap="4px"
            >
              <Box className={classes.manuallyApprovedCircleStyle} />
              <Typography variant="body2">{manuallyApprovedPhotos}</Typography>
            </Box>
          </Tooltip>
        )}
        {photosWithIssues > 0 && (
          <Tooltip title="Validation Failed">
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gridGap="4px"
            >
              <Box className={classes.problemCircleStyle} />
              <Typography variant="body2">{photosWithIssues}</Typography>
            </Box>
          </Tooltip>
        )}
      </Box>
    </Item>
  );
};
